// extracted by mini-css-extract-plugin
export default {"block":"Block_block__f4TMW","title":"Block_title__sP681","items":"Block_items__guWwE"};